import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import axios from 'axios';
import { ModalConnector } from '../../../services/modal-connection.service';
import { KycService } from '../../../services/modal-kyc/kyc.service';
import { KycService as KycServiceOriginal } from '../../../services/kyc.service';
import { SelectorsService, PhonePrefix } from '../../../services/selectors.service';
import Swal from 'sweetalert2';
import { ModalKycComponent } from '../modal-kyc.component';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { firstValueFrom } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
import { GoogleMapsLoaderService } from '../../../services/google-maps-loader.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';

declare const google: any;
export interface Nationality {
  value: string;
  viewValue: string;
}

// Retryable NeoCheck error codes (adjust as needed based on API documentation)
const RETRY_CODES = new Set<number>([3, 9, 13, 6, 7, 11, 0, 2]);

@Component({
  selector: 'app-kyc-register',
  templateUrl: './kyc-register.component.html',
  styleUrls: ['./kyc-register.component.css']
})

export class KycRegisterComponent implements OnInit, AfterViewInit {
  kycResultSub?: Subscription;

  ////////////GLOBALES////////////
  spinnerDiameter = window.innerWidth <= 480 ? 70 : 100; // Cambia 768 y 50 a los valores que necesites
  duplicatedKycSubscription: any;
  duplicatedKYC: any;


  
  //////////////// PERSON VARIABLES ///////////
  userName: string = '';
  userLastname: string = '';
  userBirthdate: Date = new Date();
  nationality: string = '';
  residence: string = '';
  address: string = '';
  city: string = '';
  mailAddress: string = '';
  phonePrefix: string = '';
  phoneNumber: string = '';
  phoneValidationError: string = '';
  // Error inline del paso "Cliente Profesional": se activa al intentar
  // continuar sin marcar al menos 2 de las 3 opciones (y la casilla general).
  professionalClientError: boolean = false;
  studyLvl: string = '';
  profession: string = '';
  sourceFunds: string = '';
  mainSourceFunds: string = '';
  sourceFundsOrigin: string = '';
  fundsPercentage: string = '';
  negative_support: string = '';
  target_invest: string = '';
  invest_goal: string = '';
  knowledge_quiebra: string = '';
  isUsaCitizen: string = ''
  isPoliticallyExposed: string = ''
  isProfessionalInvestor: string = ''
  experienceAsInvestor: string = ''
  businessManagement:string = '';
  sup500k: boolean = false;
  oper_job: boolean = false;
  // Dirección (persona)
  province: string = '';
  postalCode: string = '';
  personAddressQuery: string = '';
  selectedAddressPerson: string = '';
  personAutocompleteAvailable: boolean = false;
  isPersonManualAddress: boolean = false;
  requiredField: any = '';
  countries: Nationality[] = [];
  subscription: any;
  disablebuton: any = '';
  token:string = '';
  configuration:{}= {};
  lastoper: any = '';
  openlink2: any;
  openlink: any;
  stage1Progress: number = 0;
  stage2Progress = 0;
  stage3Progress = 0;
  currentStage = 1;
  currentStep = 1;
  url_neo_video:string ='https://neocheck.net/api/v1/VideoIdentifications/unattended/link';
  kycInfo: any = null;
  typeRegister: any
  isCompany: boolean = false;
  isPerson: boolean = false;
  phonePrefixes: PhonePrefix[]
  files: any = [];
  representants: Map<number,any> = new Map();
  index: number = 1;
  isLoading: boolean = false;
  loadingMessage: string = '';
  showKycNextButton: boolean = true;

  /////// COMPANY VARIABLES /////////
  companyName: string = '';
  companyType: string = '';
  cif:string = '';
  companyResidence:string = '';
  companyAddress:string = '';
  companyMailAddress: string = '';
  province_company: string = '';
  companyPostalCode: string = '';
  companyIsProfessionalInvestor: string = '';
  companyRepresentTitle: any;
  sup40m: boolean = false;
  companyRepresentName: any;
  companyRepresentLastname: any;
  companyRepresentBirthday: any;
  companyRepresentNationality: any;
  companyRepresentResidence: any;
  companyRepresentAddress: any;
  companyRepresentCity: any;
  companyRepresentProvince: any;
  companyPhoneNumber: any;
  companyRepresentantisUsaCitizen: any;
  companyRepresentantisPoliticallyExposed: any;
  isRealRepresentant: any;
  realRepresentantsQuantity: any;
  companyRepresentMailAddress: any;
  acta: any;
  fileacta: any;
  escrituras: any;
  filescrito: any;
  otrosdoc: any;
  fileotros: any;
  countriesApproved:string[] = ['Alemania','Austria','Bulgaria','Belgica','Chipre','Croacia','Dinamarca','Eslovaquia','Eslovenia','España','Estonia','Finlandia','Francia','Grecia','Hungría','Irlanda','Italia','Letonia','Lituania','Luxemburgo','Malta','Paises Bajos','Polonia','Portugal','Republica Checa','Rumanía','Suecia'];
  constructor(
    private afs:AngularFirestore,
    private router: Router , 
    public sanitizer: DomSanitizer, 
    public fns: AngularFireFunctions,
    public select:SelectorsService, 
    private modalConnectionService:ModalConnector ,
    private kycSrv: KycService,
    private kycService:KycServiceOriginal,
    public dialogRef: MatDialogRef<ModalKycComponent>,
    private storageService: AngularFireStorage,
    private authSrv: AuthService,
    private mapsLoader: GoogleMapsLoaderService
  ) {
    this.duplicatedKycSubscription = this.kycService.kycDuplicated.subscribe((data:Boolean | undefined | null) => {
      if(data){
        this.duplicatedKYC = true;
      }
    });
    this.countries = this.select.nacionality;
    this.phonePrefixes = this.select.phonePrefix;
   }

  ngOnInit(): void {
    // Cargar Google Maps JS (Places) para habilitar gmp-place-autocomplete
    this.mapsLoader.load(['places']).then(() => {
      this.personAutocompleteAvailable = true;
      this.isPersonManualAddress = false;
      // Forzar estilos visibles en el input del web component una vez cargado
      setTimeout(() => this.forceAutocompleteTheme(), 0);
    }).catch(() => {
      this.personAutocompleteAvailable = false;
      this.isPersonManualAddress = true;
      // Si falla la carga, la UI caerá en modo manual (inputs de texto)
    });
    this.neoToken();
    this.typeRegister = this.kycSrv.currentTypeRegister.subscribe(data => {
      if (data) {   
        /////////////////////// DEFINE TYPE INVERSOR //////////////////
        this.isCompany = data?.inversorType === 'company';
        this.isPerson = data?.inversorType === 'person';

        /////////////////////// COMPANY ATTRIBUTES /////////////////////
        this.companyName = data?.companyName;
        this.cif = data?.cif;
        this.companyType = data?.companyType;
        this.companyAddress = data?.companyAddress;
        this.province_company = data?.province_company;
        this.companyResidence = data?.companyResidence;
        this.companyMailAddress = data?.companyMailAddress;
        this.companyIsProfessionalInvestor = data?.companyIsProfessionalInvestor;
        this.companyRepresentAddress = data?.companyRepresentAddress;
        this.sup40m = data?.sup40m;
        this.requiredField = data?.profesionalClient;
        ////////////////////// SHARED ATTRIBUTES ////////////////
        this.oper_job = data?.oper_job;
        this.lastoper = data?.lastoper;
        //////////////////////////// SECOND STAGE COMPANY ////////////////////////
        this.companyRepresentTitle = data?.companyRepresentTitle;
        this.companyRepresentName = data?.companyRepresentName;
        this.companyRepresentLastname = data?.companyRepresentLastname;
        this.companyRepresentResidence = data?.companyRepresentResidence;
        this.companyRepresentMailAddress = data?.companyRepresentMailAddress;
        this.companyRepresentAddress = data?.companyRepresentAddress;
        this.companyRepresentNationality = data?.companyRepresentNationality;
        this.companyRepresentCity = data?.companyRepresentCity;
        this.companyRepresentProvince = data?.companyRepresentProvince || this.companyRepresentProvince;
        this.companyRepresentantisPoliticallyExposed = data?.companyRepresentantisPoliticallyExposed;
        this.companyRepresentantisUsaCitizen = data?.companyRepresentantisUsaCitizen;
        this.isRealRepresentant = data?.isRealRepresentant;

        ////////////////////////// PERSON //////////////////////
        this.userName = data?.nombre;
        this.userLastname = data?.apellido;
        this.address = data?.domicilio;
        this.userBirthdate = data?.fecha_de_nacimiento;
        this.mailAddress = data?.codigo_postal;
        this.nationality = data?.nacionalidad;
        this.residence = data?.pais_de_residencia;
        this.city = data?.ciudad;
        this.province = data?.provincia || data?.province_company || this.province;
        this.isUsaCitizen = data?.vive_en_usa;
        this.isPoliticallyExposed = data?.trabaja_funcion_publica;
        this.isProfessionalInvestor = data?.isProfessionalInvestor;
        this.invest_goal = data?.invest_goal;
        this.target_invest = data?.target_invest;
        this.mainSourceFunds = data?.mainSourceFunds;
        this.businessManagement = data?.businessManagement;
        this.knowledge_quiebra = data?.knowledge_quiebra;
        this.studyLvl = data?.studyLvl;
        this.profession = data?.profession;
        this.sup500k = data?.sup500k;
        this.phonePrefix = '+34'; 
      }
      this.stage1Progress = this.isCompany ? 25 : 20;
    });
    this.subscription = this.kycSrv.currentStepData.subscribe(data => {
      if (data) {
        console.log(data)
        this.currentStage = data.nextStage <= 0 ? 1 : data.nextStage;
        this.currentStep = data.nextStep <= 0 ? 1 : data.nextStep;
        this.stage1Progress = data.stage1Progress || 0;
        this.stage2Progress = data.stage2Progress || 0;
        this.stage3Progress = data.stage3Progress || 0;
        if( (this.isPerson && this.currentStep == 16 && this.currentStage == 3) || (this.isCompany && this.currentStep == 21 && this.currentStage == 3) ){
          this.kycSrv.setModalContent('stages');
        }
      }
    });

    // FIX: evitar crash si getUserUid() es null/undefined
    // NeoCheck normaliza todo a MAYÚSCULAS, usamos cleanUid (sin guiones) en MAYÚSCULAS para coincidir
    const uidRaw = this.modalConnectionService.getUserUid();
    const cleanUid = uidRaw ? uidRaw.replace(/-/g, '').toUpperCase() : '';
    if (cleanUid) {
      this.kycResultSub = this.afs.collection('kyc-results').doc(cleanUid)
        .valueChanges()
        .subscribe((userData: any) => {
          const status = userData?.status;
          // Solo avanza automáticamente si está en el paso de KYC
          if (status === 'APPROVED') {
            if ((this.isPerson && this.currentStep === 15) || (this.isCompany && this.currentStep === 20)) {
              this.isLoading = false;
              this.disablebuton = false;
              this.nextStep();
            }
          }
        });
    }
  }

  ngAfterViewInit(): void {
    // Aplicar forzado de tema tras montar la vista por si el script ya estaba cargado
    setTimeout(() => this.forceAutocompleteTheme(), 0);
  }
  
  async neoToken() {
    this.fns.httpsCallable('neoToken')({}).subscribe(async (res:any) =>{
      if (!res.success) { return; }
      this.token = res.token;
      let video = String(await this.getToken())
      this.openlink =  this.sanitizer.bypassSecurityTrustResourceUrl(video);
    });
  }

  async getToken() {
    const userUid = this.modalConnectionService.getUserUid();
    if (!userUid) {
      console.error("User UID is not available for NeoCheck token generation.");
      // Optionally, show a user-facing error or prevent proceeding
      Swal.fire('Error', 'No se pudo obtener el identificador de usuario. Por favor, intente de nuevo más tarde.', 'error');
      return Promise.reject("User UID not found");
    }
    // NeoCheck normaliza todo a MAYÚSCULAS, por lo que normalizamos aquí para mantener consistencia
    const cleanUid = userUid.replace(/-/g, '').toUpperCase();

    return new Promise(async(resolve,reject)=> {
        // externalIdentifier is now a URL parameter
        const requestUrl = `${this.url_neo_video}?externalIdentifier=${encodeURIComponent(cleanUid)}`;
        
        const payload = {
          // externalId: cleanUid, // Removed from payload
          language:"es", // Restoring language and companyname to the payload 
          companyname:"Domoblock", // as externalIdentifier is now in URL
          // notificationApiUrl:`${environment.api.url}/notifications/KYC-verification`
        };

        this.configuration = {headers: { Authorization: `Bearer ${this.token}`}};
        await axios.post(requestUrl, payload, // Use the new requestUrl and the payload
        this.configuration).then((response) => {
           this.openlink = response.data;
           this.openlink2 = response.data;
          return (this.openlink);
        }).catch(error => {
          console.error('Error generating verification link with externalId:', error);
          Swal.fire({
            icon: 'error',
            titleText: 'Error de verificación',
            text: 'Ha ocurrido un error al generar el enlace de verificación. Por favor, inténtalo de nuevo más tarde.',
            confirmButtonText: 'Aceptar'
          });
          reject(error); // reject the promise on error
        });
      resolve(this.openlink)
    });
  }

  async delay(){
    return new Promise(resolve => setTimeout(resolve, 5000));
  }
  
  // Regenera el enlace de video: limpia estado y solicita un nuevo token
  private regenerateVideoLink(): void {
    this.kycSrv.isInNeocheckStep(true);
    this.openlink = null as any;
    this.openlink2 = null as any;
    this.token = '';
    this.neoToken();
  }

  /**
   * Extrae el número de identificación del documento correcto del resultado de NeoCheck
   * - Para Pasaporte: SOLO Número de Documento (nunca Número Personal)
   * - Para DNI/NIE: SOLO Número Personal (nunca Número de Documento/soporte)
   */
  private extractDocumentIdentificationFromNeoCheck(neocheckResponse: any): string | undefined {
    // La CF puede devolver: res.data, res.data.data (anidado), o datos en la raíz de res
    const rawData = neocheckResponse?.data ?? neocheckResponse;
    if (!rawData || typeof rawData !== 'object') {
      return undefined;
    }
    const data = rawData?.data && typeof rawData.data === 'object' ? rawData.data : rawData;
    
    // Detectar tipo de documento (en data y en documentData por si la API lo envía ahí)
    let documentType = data.DocumentType || data.documentType || 
                      data.DocumentTypeCode || data.documentTypeCode;
    
    // Obtener ambos números directamente de data (camelCase y PascalCase)
    const documentNumber = data.DocumentNumber || data.documentNumber;
    const personalNumber = data.PersonalNumber || data.personalNumber;
    
    // Buscar en documentData array (estructura que devuelve NeoCheck)
    let documentNumberFromArray: string | undefined;
    let personalNumberFromArray: string | undefined;
    if (data.documentData && Array.isArray(data.documentData)) {
      for (const element of data.documentData) {
        const type = String(element?.type || '').toLowerCase().trim();
        const name = String(element?.name || '').trim();
        const value = element?.value != null ? String(element.value).trim() : '';
        if (!value) continue;
        // Número de documento (pasaporte = este valor; type "DocumentNumber" o name "Número de Documento")
        if (/documentnumber|numerodocumento|numero\s*de\s*documento|número\s*de\s*documento|document\s*number/i.test(type) ||
            name === 'Número de Documento' || name.toLowerCase() === 'número de documento') {
          documentNumberFromArray = value;
        }
        // Número personal (DNI = este valor; pasaporte = no usar)
        if (/personalnumber|numeropersonal|numero\s*personal|número\s*personal|personal\s*number/i.test(type) ||
            name === 'Número Personal' || name.toLowerCase() === 'número personal') {
          personalNumberFromArray = value;
        }
        // Tipo de documento puede venir en el array
        if ((type === 'documenttype' || type === 'documenttypecode' || type === 'tipo de documento' || name === 'Tipo de Documento') && !documentType) {
          documentType = value;
        }
      }
    }
    
    const documentTypeStr = String(documentType || '').toUpperCase().trim();
    const isPassport = documentTypeStr === 'P' || 
                       documentTypeStr === 'PASSPORT' ||
                       documentTypeStr.includes('PASSPORT');
    const isIdCard = documentTypeStr === 'IDC' || documentTypeStr === 'IDCARD' || 
                     documentTypeStr === 'ID CARD' || documentTypeStr.includes('IDCARD') || 
                     (documentTypeStr.includes('ID') && !documentTypeStr.includes('PASSPORT'));
    
    if (isPassport) {
      // Pasaporte: usar ÚNICAMENTE Número de Documento (nunca DocumentIdentification ni PersonalNumber; el backend a veces devuelve el personal aquí)
      const chosen = documentNumberFromArray || documentNumber || undefined;
      console.debug('[KYC][extractDocumentId][passport]', { 
        documentNumber, 
        documentNumberFromArray,
        chosen, 
        documentType: documentTypeStr,
        personalNumberIgnored: personalNumber || personalNumberFromArray 
      });
      return chosen;
    }
    
    if (isIdCard) {
      // DNI/NIE: usar únicamente Número Personal
      const chosen = personalNumberFromArray || personalNumber || undefined;
      console.debug('[KYC][extractDocumentId][idcard]', { 
        personalNumber, 
        personalNumberFromArray,
        chosen, 
        documentType: documentTypeStr 
      });
      return chosen;
    }
    
    // Tipo desconocido: priorizar Número de Documento (por si es pasaporte y el tipo no vino)
    const chosen = documentNumberFromArray || documentNumber || 
                   personalNumberFromArray || personalNumber || undefined;
    console.debug('[KYC][extractDocumentId][unknown]', { 
      documentNumber, 
      documentNumberFromArray,
      personalNumber, 
      personalNumberFromArray,
      chosen, 
      documentType: documentTypeStr || '(vacío)' 
    });
    return chosen;
  }

  // Construye el payload que se enviará a saveKycData
  private buildSavePayload(neoId?: string, neocheckResponse?: any): any {
    // Siempre extraer documentIdentification desde la respuesta con la regla correcta:
    // Pasaporte → Número de Documento; DNI/NIE → Número Personal (no usar el valor del backend que puede venir mal)
    let documentIdentification: string | undefined;
    if (neocheckResponse) {
      documentIdentification = this.extractDocumentIdentificationFromNeoCheck(neocheckResponse);
    }
    if (!documentIdentification && neocheckResponse?.documentIdentification) {
      documentIdentification = neocheckResponse.documentIdentification;
    }
    // Para que saveKycData siempre se ejecute: si hay respuesta pero no número, o si no hay respuesta (error neocheckKYC), usar neoId como fallback
    if (!documentIdentification && neoId) {
      documentIdentification = neoId;
    }
    
    const payload: any = {
      isPerson: !!this.isPerson,
      isCompany: !!this.isCompany,
      neoId: neoId || undefined
    };
    
    // Incluir kycData siempre que tengamos algo que guardar (evita que la CF rechace por falta de kycData)
    if (documentIdentification) {
      payload.kycData = {
        documentIdentification: documentIdentification
      };
    }

    if (this.isCompany) {
      // Representante principal
      const rep = {
        nombre: this.companyRepresentName || '',
        apellido1: this.companyRepresentLastname || '',
        apellido2: '',
        domicilio: this.companyRepresentAddress || '',
        telefono: this.companyPhoneNumber ? `${this.phonePrefix}${this.companyPhoneNumber}` : '',
        ciudad: this.companyRepresentCity || '',
        provincia: this.companyRepresentProvince || '',
        codigo_postal: this.companyRepresentMailAddress || '',
        nacionalidad: this.companyRepresentNationality || '',
        fecha_de_nacimiento: this.companyRepresentBirthday || '',
        pais_de_residencia: this.companyRepresentResidence || '',
        vive_en_usa: this.companyRepresentantisUsaCitizen || '',
        trabaja_funcion_publica: this.companyRepresentantisPoliticallyExposed || '',
        empresa_titulo: this.companyRepresentTitle || ''
      };
      payload.representante = deepClean(rep);
      // Titulares reales (si aplica)
      payload.representants = Array.from(this.representants.values()).map(r => deepClean(r));
      // Datos básicos de empresa
      payload.company = deepClean({
        companyName: this.companyName,
        cif: this.cif,
        companyType: this.companyType,
        companyAddress: this.companyAddress,
        province_company: this.province_company,
        companyResidence: this.companyResidence,
        companyMailAddress: this.companyMailAddress || this.companyPostalCode || '',
        companyIsProfessionalInvestor: this.companyIsProfessionalInvestor,
        sup40m: this.sup40m,
        profesionalClient: this.requiredField
      });
    } else {
      // Datos de persona
      payload.person = deepClean({
        nombre: this.userName,
        apellido: this.userLastname,
        fecha_de_nacimiento: this.userBirthdate,
        nacionalidad: this.nationality,
        pais_de_residencia: this.residence,
        domicilio: this.address,
        ciudad: this.city,
        provincia: this.province || this.province_company || '',
        codigo_postal: this.mailAddress || this.postalCode || '',
        telefono: this.phoneNumber ? `${this.phonePrefix}${this.phoneNumber}` : '',
        profession: this.profession,
        studyLvl: this.studyLvl,
        mainSourceFunds: this.mainSourceFunds,
        sourceFunds: this.sourceFunds,
        sourceFundsOrigin: this.sourceFundsOrigin,
        fundsPercentage: this.fundsPercentage,
        negative_support: this.negative_support,
        target_invest: this.target_invest,
        invest_goal: this.invest_goal,
        businessManagement: this.businessManagement,
        knowledge_quiebra: this.knowledge_quiebra,
        isProfessionalInvestor: this.isProfessionalInvestor,
        vive_en_usa: this.isUsaCitizen,
        trabaja_funcion_publica: this.isPoliticallyExposed,
        lastoper: this.lastoper,
        sup500k: this.sup500k,
        oper_job: this.oper_job
      });
    }

    return payload;
  }

  // Invoca saveKycData y no rompe el flujo si falla
  private async persistKycData(payload: any): Promise<void> {
    try {
      console.debug('[KYC] Llamando saveKycData con payload', {
        hasKycData: !!payload?.kycData,
        documentIdentification: payload?.kycData?.documentIdentification || '(no enviado)',
        neoId: payload?.neoId
      });
      await firstValueFrom(this.fns.httpsCallable('saveKycData')(payload));
    } catch (e) {
      console.error('[Front] saveKycData error (continuando flujo):', e);
    }
  }

  /**
   * Actualiza el campo kyc.result en el documento del usuario en Firestore
   * @param result - 0: rechazado, 1: aprobado, 2: en revisión
   * @param documentIdentification - Identificador del documento (neoId)
   */
  private async updateUserKycResult(result: number, documentIdentification?: string): Promise<void> {
    try {
      const userUid = this.modalConnectionService.getUserUid();
      if (!userUid) {
        console.warn('[Front] No se puede actualizar kyc.result: userUid no disponible');
        return;
      }

      const kycUpdate: any = {
        kyc: {
          result: result
        }
      };

      // Si se proporciona documentIdentification, agregarlo
      if (documentIdentification) {
        kycUpdate.kyc.documentIdentification = documentIdentification;
      }

      // Agregar timestamp de actualización
      kycUpdate.kyc.updatedAt = new Date();

      await this.afs.collection('users').doc(userUid).set(kycUpdate, { merge: true });
      console.log(`[Front] ✅ kyc.result actualizado a ${result} para usuario ${userUid}`);
    } catch (error) {
      console.error('[Front] ❌ Error al actualizar kyc.result:', error);
      // No lanzamos el error para no romper el flujo principal
    }
  }

  async saveUserData() {
    this.loadingMessage = `Verificando ${this.isPerson ? 'KYC' : 'KYB'}...
<span class="kyc-loading-message-small">Este proceso puede demorar unos minutos,\n no cierre o refresque la ventana por favor.</span>`;
    this.isLoading = true;

    try {
      // 1) Validaciones básicas del enlace
      if (!this.openlink2) {
        this.isLoading = false;
        // Sin alertas redundantes; volver a generar link
        this.regenerateVideoLink();
        return;
      }
      // NeoCheck normaliza todo a MAYÚSCULAS, normalizamos el neoId para mantener consistencia
      const neoId = String(this.openlink2)
        .replace('https://safeonboarding.net/VideoIdentification/Index/', '')
        .replace('?language=es', '')
        .toUpperCase();
      if (!neoId) {
        this.isLoading = false;
        this.regenerateVideoLink();
        return;
      }

      // 2) Esperar 5s antes de consultar a NeoCheck vía CF
      await this.delay();

      // 3) Validación en la Cloud (neocheckKYC)
      let res: any;
      try {
        res = await firstValueFrom(this.fns.httpsCallable('neocheckKYC')(neoId));
      } catch (err) {
        console.error('[Front] Error neocheckKYC:', err);
        // Aunque neocheckKYC falle (ej. pasaporte caducado, timeout), ejecutar saveKycData para guardar datos del formulario
        const payloadError = this.buildSavePayload(neoId, null);
        await this.persistKycData(payloadError);
        this.isLoading = false;
        this.regenerateVideoLink();
        return;
      }
      console.log(res)
      // 4) Decisión de UI según CF
      if (res?.success === false) {
        this.isLoading = false;

        let kycState: any = {};
        try {
          const u = await this.modalConnectionService.getUserData();
          kycState = u?.kyc || {};
        } catch {}

        const isRejected = kycState?.result === 0;
        const isReview = kycState?.result === 2;
        
        if (isRejected || isReview) {
          this.kycSrv.isInNeocheckStep(false);
          this.disablebuton = false;
          this.kycSrv.setModalContent('completed');
          // moved
          const payloadReview = this.buildSavePayload(neoId, res);
          await this.persistKycData(payloadReview);
          // Actualizar kyc.result con el documentIdentification correcto (pasaporte = Número de Documento, DNI = Número personal)
          if (isReview) {
            const docId = payloadReview.kycData?.documentIdentification || res?.documentIdentification || neoId;
            await this.updateUserKycResult(2, docId);
          }
          return;
        }

        // Parche: aunque falle la verificación (ej. pasaporte caducado), guardar igual los datos en saveKycData
        const payloadFail = this.buildSavePayload(neoId, res);
        await this.persistKycData(payloadFail);

        const code = res?.code;
        const isRetry = typeof code === 'number' && RETRY_CODES.has(code);

        await Swal.fire({
          titleText: 'Problema con la verificación',
          text: res?.message || 'Repite de nuevo la verificación.',
          confirmButtonText: 'Reintentar',
          icon: 'warning'
        });

        if (isRetry) {
          // Volver al modo vídeo-identificación
          this.kycSrv.isInNeocheckStep(true);
          this.disablebuton = true;
          // Opcional: reposicionar pasos si algo los cambió
          if (this.isPerson) {
            this.currentStage = 3;
            this.currentStep = 15;
          } else if (this.isCompany) {
            this.currentStage = 3;
            this.currentStep = 20;
          }
          this.neoToken();          // o this.regenerateVideoLink(), según uses
        } else {
          // Otros errores: mantener comportamiento actual
          this.regenerateVideoLink();
        }

        return;
      }

      if (res?.success === true && res?.status === 'En revisión') {
        // Guardar SIEMPRE en revisión
        const payloadReview = this.buildSavePayload(neoId, res);
        await this.persistKycData(payloadReview);

        // Guardar externalIdentifier en el documento del usuario para poder buscarlo en Firebase
        // Solo se guarda si no existe ya para evitar guardarlo múltiples veces
        const userUid = this.modalConnectionService.getUserUid();
        if (userUid) {
          const userDoc = await firstValueFrom(this.afs.collection('users').doc(userUid).get());
          const userData = userDoc.data() as any;
          if (!userData?.externalIdentifier) {
            const externalIdentifier = userUid.replace(/-/g, '').toUpperCase();
            await this.afs.collection('users').doc(userUid).set({
              externalIdentifier: externalIdentifier
            }, { merge: true });
          }
        }

        // Actualizar kyc.result = 2 (en revisión) con el documentIdentification correcto (pasaporte = Número de Documento)
        const docIdReview = payloadReview.kycData?.documentIdentification || res?.documentIdentification || neoId;
        await this.updateUserKycResult(2, docIdReview);

        // Cerrar iframe y navegar a "En revisión"
        this.isLoading = false;
        this.kycSrv.isInNeocheckStep(false);
        this.disablebuton = false;
        this.kycSrv.setModalContent('completed');
        return;
      }

      // Aprobado
      const payloadApproved = this.buildSavePayload(neoId, res);
      await this.persistKycData(payloadApproved);

      // Guardar externalIdentifier en el documento del usuario para poder buscarlo en Firebase
      // Solo se guarda si no existe ya para evitar guardarlo múltiples veces
      const userUid = this.modalConnectionService.getUserUid();
      if (userUid) {
        const userDoc = await firstValueFrom(this.afs.collection('users').doc(userUid).get());
        const userData = userDoc.data() as any;
        if (!userData?.externalIdentifier) {
          const externalIdentifier = userUid.replace(/-/g, '').toUpperCase();
          await this.afs.collection('users').doc(userUid).set({
            externalIdentifier: externalIdentifier
          }, { merge: true });
        }
      }

      // Actualizar kyc.result = 1 (aprobado) con el documentIdentification correcto (pasaporte = Número de Documento, DNI = Número personal)
      const docIdApproved = payloadApproved.kycData?.documentIdentification || res?.documentIdentification || neoId;
      await this.updateUserKycResult(1, docIdApproved);

      this.kycSrv.isInNeocheckStep(false);
      setTimeout(() => {
        this.isLoading = false;
        if (this.duplicatedKYC) {
          this.kycSrv.setModalContent('completed');
          return;
        }
        this.backToKycStages();
      }, 12000);

    } catch (err) {
      console.error('[Front] Error inesperado en saveUserData:', err);
      // En error inesperado no guardamos (solo aprobado/revisión guardan)
      this.isLoading = false;
      this.regenerateVideoLink();
    }
  }
  

  delayButton() {
    setTimeout(() => {
      this.disablebuton = false
    }, 100000);
  }

  backStep() {
    this.decrementCurrentStep();
    this.decrementCurrentStagePercentage();
  }

  async nextStep() {
    let data = {} as any
    switch(this.getCurrentStep()) {
      case 1:{
        if(this.isPerson){
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Asegúrate de que la fecha de hoy no tenga información de tiempo
  
          if (this.userName === '' || this.userLastname === '' || 
              !this.userBirthdate || this.userBirthdate > today) {
            this.mandatoryFields();
          return;
          }
  
          const userBirthdate = new Date(this.userBirthdate);
  
          let age = today.getFullYear() - userBirthdate.getFullYear();
          const m = today.getMonth() - userBirthdate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < userBirthdate.getDate())) {
            age--;
          }
  
          if (age < 18 && this.isPerson) {
            Swal.fire({
              icon: 'error',
              title: 'Eres menor de edad',
              text: '¡Recuerda que para poder invertir con Domoblock debes tener mas de 18 años!',
            });
            return;
          }
          
          data = {
            nombre:this.userName,
            apellido:this.userLastname,
            fecha_de_nacimiento:this.userBirthdate
          }
        }else{
          
          if(!this.companyName || !this.cif || !this.companyType){
            this.mandatoryFields();
            return;
          }
          data = {
            companyName:this.companyName,
            cif:this.cif,
            companyType:this.companyType
          }
        }
        break;
      }
      case 2:{
        if(this.isPerson){
          if (!this.nationality || !this.residence) {
            this.mandatoryFields();
            return;
          }
          data = {
            nacionalidad:this.nationality,
            pais_de_residencia:this.residence,
          }
        }
        else{
          if(!this.companyAddress || !this.companyResidence || !this.province_company || !this.companyMailAddress){
            // Guiar al usuario a completar provincia/código postal si faltan
            if (this.companyAddress) {
              await this.ensureAddressCompleteness('company');
            }
            if(!this.companyAddress || !this.companyResidence || !this.province_company || !this.companyMailAddress){
              this.mandatoryFields();
              return;
            }
          }
          data = {
            companyAddress: this.companyAddress,
            companyResidence: this.companyResidence,
            province_company: this.province_company,
            companyMailAddress: this.companyMailAddress
          }
        }
        break;
      }
      case 3:{
        if(this.isPerson){
          // Nueva validación estricta de dirección (persona)
          const street = this.address?.trim() || '';
          const city = this.city?.trim() || '';
          const province = (this.province || this.province_company || '').trim();
          const postalRaw = (this.mailAddress || this.postalCode || '').trim();
          const country = (this.residence || 'España').trim();

          // Helper: formato mínimo calle (letra + número)
          const streetValid = /[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/.test(street) && /\d/.test(street) && street.length >= 5;
          // Postal válido según país (España estricto, otros: 3-10 alfanumérico)
          const postalValid = this.isValidPostalCode(country, postalRaw);

          if (!street || !city || !province || !postalRaw) {
            // Intentar autocompletar faltantes si hay algo de address
            if (street) await this.ensureAddressCompleteness('person');
            if (!street || !city || !province || !postalRaw) {
              this.mandatoryFields();
              return;
            }
          }
          if (!streetValid) {
            // Permitir direcciones sin número si no es España
            const isSpain = country.toLowerCase() === 'españa' || country.toLowerCase() === 'spain';
            if (isSpain) {
              await Swal.fire({
                title: 'Dirección inválida',
                text: 'Incluya nombre de vía y número (ej: "Calle Mayor 10").',
                icon: 'warning'
              });
              return;
            }
          }
          if (!postalValid) {
            await Swal.fire({
              title: 'Código postal inválido',
              text: country.toLowerCase() === 'españa' || country.toLowerCase() === 'spain'
                ? 'El código postal debe ser 5 dígitos válidos en España.'
                : 'Formato de código postal no reconocido. Use entre 3 y 10 caracteres (letras/números).',
              icon: 'warning'
            });
            return;
          }
          data = {
            domicilio:this.address,
            ciudad:this.city,
            provincia: this.province || this.province_company || '',
            codigo_postal:this.mailAddress
          }
        }else{
          if(!this.fileacta || !this.filescrito){
            this.mandatoryFields();
            return;
          }
        }
        break;
      }
      case 4:{
        if(this.isPerson){
          if (this.phonePrefix === '' || this.phoneNumber === '') {
            this.mandatoryFields();
          return;
          }
          // Validar número de teléfono español antes de continuar
          if (this.phonePrefix === '+34') {
            this.validateSpanishPhone();
            if (this.phoneValidationError) {
              this.showPhoneValidationError();
              return;
            }
          }
          data = {
            telefono: `${this.phonePrefix}${this.phoneNumber}`
          }
        }else{
          if(!this.companyIsProfessionalInvestor){
            this.mandatoryFields();
            return;
          }
          data = {
            companyIsProfessionalInvestor:this.companyIsProfessionalInvestor
          }
          if (this.companyIsProfessionalInvestor === 'No') this.incrementCurrentStep();
        }
        break;
      }
      case 5:{
        if(this.isPerson){
          if (!this.isUsaCitizen || !this.isPoliticallyExposed) {
            this.mandatoryFields();
            return;
          }
          this.incrementCurrentStep();
          data = {
            vive_en_usa:this.isUsaCitizen,
            trabaja_funcion_publica:this.isPoliticallyExposed
        }
      }
      else{
        // Cliente Profesional (empresa): casilla general + al menos 2 de las 3 opciones.
        if (!this.professionalSelectionValid) {
          this.professionalClientError = true;
          return;
        }
        this.professionalClientError = false;
        data = {
          profesionalClient: this.requiredField,
          lastoper:this.lastoper || '',
          sup40m:this.sup40m || '',
          oper_job:this.oper_job || ''
        }
      }
        break;
      }
      case 6: {
        if(this.isPerson) this.incrementCurrentStep();
        if(this.isCompany){
          if(!this.companyRepresentTitle){
            this.mandatoryFields();
            return;
          }
          data = {
            companyRepresentTitle:this.companyRepresentTitle
          }
        }
        break;
      }
      case 7:{
        if(this.isPerson){
          if (!this.profession || !this.studyLvl || !this.mainSourceFunds) {
            this.mandatoryFields();
          return;
          }
          data = {
            profession: this.profession,
            studyLvl: this.studyLvl,
            mainSourceFunds:this.mainSourceFunds
          }
        }
        if(this.isCompany){

          if(!this.companyRepresentName || !this.companyRepresentLastname || !this.companyRepresentBirthday){
              this.mandatoryFields();
              return;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const userBirthdate = new Date(this.companyRepresentBirthday);
  
            let age = today.getFullYear() - userBirthdate.getFullYear();
            const m = today.getMonth() - userBirthdate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < userBirthdate.getDate())) {
              age--;
            }
    
            if (age < 18) {
              Swal.fire({
                icon: 'error',
                title: 'Eres menor de edad',
                text: '¡Recuerda que para poder invertir con Domoblock debes tener mas de 18 años!',
              });
              return;
            }

          data = {
            companyRepresentName: this.companyRepresentName,
            companyRepresentLastname: this.companyRepresentLastname,
            companyRepresentBirthday: this.companyRepresentBirthday
          }

        }
        break;
      }
      case 8:{
        if(this.isPerson){
          if (!this.sourceFunds || !this.sourceFundsOrigin || !this.fundsPercentage) {
            this.mandatoryFields();
            return;
          }
          data = {
            sourceFunds:this.sourceFunds,
            sourceFundsOrigin:this.sourceFundsOrigin,
            fundsPercentage: this.fundsPercentage
          }
        }
        if(this.isCompany){
            if(!this.companyRepresentNationality || !this.companyRepresentResidence){
            this.mandatoryFields();
            return;
          }

          data = {
            companyRepresentNationality: this.companyRepresentNationality,
            companyRepresentResidence: this.companyRepresentResidence
          }
          }
        break;
      }
      case 9:{
        if(this.isPerson){
          if (!this.negative_support || !this.target_invest || !this.invest_goal) {
            this.mandatoryFields();
          return;
          }
          data = {
            negative_support:this.negative_support,
            target_invest:this.target_invest,
            invest_goal:this.invest_goal
          }
        }
        else{
          if(!this.companyRepresentAddress || !this.companyRepresentCity || !this.companyRepresentProvince || !this.companyRepresentMailAddress || !this.companyRepresentResidence){
              if (this.companyRepresentAddress) {
                await this.ensureAddressCompleteness('rep');
              }
              if(!this.companyRepresentAddress || !this.companyRepresentCity || !this.companyRepresentProvince || !this.companyRepresentMailAddress || !this.companyRepresentResidence){
                this.mandatoryFields();
                return;
              }
          }

          // Validar código postal
          const country = this.companyRepresentResidence || 'España';
          const postalRaw = this.companyRepresentMailAddress || '';
          if (!this.isValidPostalCode(country, postalRaw)) {
             await Swal.fire({
              title: 'Código postal inválido',
              text: (country.toLowerCase() === 'españa' || country.toLowerCase() === 'spain')
                ? 'El código postal debe ser 5 dígitos válidos en España.'
                : 'Formato de código postal no reconocido. Use entre 3 y 10 caracteres (letras/números).',
              icon: 'warning'
            });
            return;
          }

          data = {
            companyRepresentAddress:this.companyRepresentAddress,
            companyRepresentCity:this.companyRepresentCity,
            companyRepresentProvince:this.companyRepresentProvince,
            companyRepresentMailAddress:this.companyRepresentMailAddress
          }
        }
        break;
      }
      case 10:{
        if(this.isPerson){
          if (!this.businessManagement || !this.knowledge_quiebra) {
            this.mandatoryFields();
           return;
          }
  
         data = {
           businessManagement: this.businessManagement,
           knowledge_quiebra:this.knowledge_quiebra,
         } 
        }else{
           if(!this.phonePrefix || !this.companyPhoneNumber){
            this.mandatoryFields();
            return;
          }
          // Validar número de teléfono español antes de continuar
          if (this.phonePrefix === '+34') {
            this.validateSpanishPhone();
            if (this.phoneValidationError) {
              this.showPhoneValidationError();
              return;
            }
          }

          data = {
            companyPhoneNumber: `${this.phonePrefix}${this.companyPhoneNumber}`
          }
      }
        break;
      }
      case 11:{
        if(this.isPerson){
          if (!this.isProfessionalInvestor) {
            this.mandatoryFields();
            return;
          }
  
          if ( this.isProfessionalInvestor === 'No' ) this.incrementCurrentStep();
          data = {
            isProfessionalInvestor:this.isProfessionalInvestor,
          } 
        }else{

          if(!this.companyRepresentantisUsaCitizen || 
            !this.companyRepresentantisPoliticallyExposed){
              this.mandatoryFields();
              return;
            }
            // Save latest rep flags plus full representante snapshot
            const representanteSnap = {
              nombre: this.companyRepresentName || '',
              apellido1: this.companyRepresentLastname || '',
              apellido2: '',
              domicilio: this.companyRepresentAddress || '',
              telefono: this.companyPhoneNumber ? `${this.phonePrefix}${this.companyPhoneNumber}` : '',
              ciudad: this.companyRepresentCity || '',
              provincia: this.companyRepresentProvince || '',
              codigo_postal: this.companyRepresentMailAddress || '',
              nacionalidad: this.companyRepresentNationality || '',
              fecha_de_nacimiento: this.companyRepresentBirthday || '',
              pais_de_residencia: this.companyRepresentResidence || '',
              vive_en_usa: this.companyRepresentantisUsaCitizen || '',
              trabaja_funcion_publica: this.companyRepresentantisPoliticallyExposed || '',
              empresa_titulo: this.companyRepresentTitle || ''
            };
            data = {
              companyRepresentantisUsaCitizen: this.companyRepresentantisUsaCitizen,
              companyRepresentantisPoliticallyExposed: this.companyRepresentantisPoliticallyExposed,
              representante: representanteSnap
            }
        }
        break;
      }
      case 12:{
        if(this.isPerson){
          // Cliente Profesional (particular): casilla general + al menos 2 de las 3 opciones.
          if (!this.professionalSelectionValid) {
            this.professionalClientError = true;
            return;
          }
          this.professionalClientError = false;
          data = {
            lastoper:this.lastoper || '',
            sup500k:this.sup500k || '',
            oper_job:this.oper_job  || ''
          }
        }else{
          if (!this.isRealRepresentant) {
            this.mandatoryFields();
            return;
          }
          if (this.isRealRepresentant === 'Si') {
            this.currentStep = 18;
          }
          data = {
            isRealRepresentant:this.isRealRepresentant
           }
        }
        break;
      }
      case 13:{
        if (this.isPerson) {
          this.incrementCurrentStep();
        }else{
          if(this.realRepresentantsQuantity < 1 || this.realRepresentantsQuantity > 5){
            Swal.fire({
              title:'Número de titulares inválido',
              text:'Por favor, selecciona un número de titulares válido. Entre 1 y 5',
              icon: 'warning'
            })
            return;
          }
          // Persist number of titulares immediately
          data = { realRepresentantsQuantity: this.realRepresentantsQuantity };
          this.clearFields();
        }
        break;
      }
      case 14:{
          if (this.isPerson) {
          this.disablebuton = true;
          this.delayButton();
          }

          if (this.isCompany) {
            if(!this.companyRepresentName || 
            !this.companyRepresentLastname || 
            !this.companyRepresentBirthday){
              this.mandatoryFields();
              return;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const userBirthdate = new Date(this.companyRepresentBirthday);
  
            let age = today.getFullYear() - userBirthdate.getFullYear();
            const m = today.getMonth() - userBirthdate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < userBirthdate.getDate())) {
              age--;
            }
    
            if (age < 18) {
              Swal.fire({
                icon: 'error',
                title: 'Este titular es menor de edad',
                text: '¡Recuerda que para poder invertir con Domoblock debe tener mas de 18 años!',
              });
              return;
            }

            this.representants.set(this.index,{
              ...this.representants.get(this.index),
              companyRepresentName:this.companyRepresentName,
              companyRepresentLastname:this.companyRepresentLastname,
              companyRepresentBirthday:this.companyRepresentBirthday
            })
            // Persist current titular fields immediately
            data = {
              companyRepresentName: this.companyRepresentName,
              companyRepresentLastname: this.companyRepresentLastname,
              companyRepresentBirthday: this.companyRepresentBirthday
            };

          }
        break;
      }
      case 15:{
        if (this.isCompany) {
          if(!this.companyRepresentNationality || !this.companyRepresentResidence){
          this.mandatoryFields();
          return;
          }
          this.representants.set(this.index,{
              ...this.representants.get(this.index),
              companyRepresentNationality:this.companyRepresentNationality,
              companyRepresentResidence:this.companyRepresentResidence          
            })
          // Persist nationality/residence immediately
          data = {
            companyRepresentNationality: this.companyRepresentNationality,
            companyRepresentResidence: this.companyRepresentResidence
          };

        }
        break;
      }
      case 16:{
          if(!this.companyRepresentAddress || !this.companyRepresentCity || !this.companyRepresentProvince || !this.companyRepresentMailAddress || !this.companyRepresentResidence){
            if (this.companyRepresentAddress) {
              await this.ensureAddressCompleteness('rep');
            }
            if(!this.companyRepresentAddress || !this.companyRepresentCity || !this.companyRepresentProvince || !this.companyRepresentMailAddress || !this.companyRepresentResidence){
              this.mandatoryFields();
              return;
            }
          }

          // Validar código postal (Titulares)
          const country = this.companyRepresentResidence || 'España';
          const postalRaw = this.companyRepresentMailAddress || '';
          if (!this.isValidPostalCode(country, postalRaw)) {
             await Swal.fire({
              title: 'Código postal inválido',
              text: (country.toLowerCase() === 'españa' || country.toLowerCase() === 'spain')
                ? 'El código postal debe ser 5 dígitos válidos en España.'
                : 'Formato de código postal no reconocido. Use entre 3 y 10 caracteres (letras/números).',
              icon: 'warning'
            });
            return;
          }

          this.representants.set(this.index,{
            ...this.representants.get(this.index),
            companyRepresentAddress:this.companyRepresentAddress,
            companyRepresentCity:this.companyRepresentCity,
            provincia:this.companyRepresentProvince,
            companyRepresentMailAddress:this.companyRepresentMailAddress
          })
          // Persist address + current representants array immediately
          data = {
            companyRepresentAddress: this.companyRepresentAddress,
            companyRepresentCity: this.companyRepresentCity,
            companyRepresentProvince: this.companyRepresentProvince,
            companyRepresentMailAddress: this.companyRepresentMailAddress,
            representants: Array.from(this.representants.values())
          };

        break;
      }
      case 17:{
        if (this.isCompany) {
               if(!this.phonePrefix || !this.companyPhoneNumber){
            this.mandatoryFields();
            return;
          }
          // Validar número de teléfono español antes de continuar
          if (this.phonePrefix === '+34') {
            this.validateSpanishPhone();
            if (this.phoneValidationError) {
              this.showPhoneValidationError();
              return;
            }
          }
          this.representants.set(this.index,{
            ...this.representants.get(this.index),
            companyPhoneNumber: `${this.phonePrefix}${this.companyPhoneNumber}`
        })
        // Persist phone + representants array immediately
        data = {
          companyPhoneNumber: `${this.phonePrefix}${this.companyPhoneNumber}`,
          representants: Array.from(this.representants.values())
        };

        }
        break;
      }
      case 18:{
        if (this.isCompany) {
          if(!this.companyRepresentantisUsaCitizen || 
            !this.companyRepresentantisPoliticallyExposed){
              this.mandatoryFields();
              return;
            }
            this.representants.set(this.index,{
              ...this.representants.get(this.index),
              companyRepresentantisUsaCitizen:this.companyRepresentantisUsaCitizen,
              companyRepresentantisPoliticallyExposed:this.companyRepresentantisPoliticallyExposed
            })
            // Persist latest flags + representants array immediately
            data = {
              companyRepresentantisUsaCitizen: this.companyRepresentantisUsaCitizen,
              companyRepresentantisPoliticallyExposed: this.companyRepresentantisPoliticallyExposed,
              representants: Array.from(this.representants.values())
            };
            if(this.index < this.realRepresentantsQuantity){
              this.clearFields();
              this.currentStep = 13;
              this.index++;
            }
        }
        break;
      }

      case 19:{
        if(this.isCompany){    
          const representants = Array.from(this.representants.values())
          data = {representants}
          this.disablebuton = true;
          this.delayButton();
        }
        break;
      }

      default:{
        //TODO
        break;
      }
    }
    this.incrementCurrentStep()
    this.incrementCurrentStagePercentage();
    /*
    if (this.stage3Progress > 100) {
      if (this.isPerson) return;
    } */

    if (this.isPerson) {
      console.log(this.currentStep)
    switch (this.currentStep) {
      case 7:
        this.setCurrentStage(2);
        this.incrementCurrentStagePercentage();
        break;
      case 13:
        this.setCurrentStage(3);
        this.incrementCurrentStagePercentage();
        this.incrementCurrentStep();
        this.kycSrv.isInNeocheckStep(true);
        break;
      case 16:
        this.saveUserData();
        break;
      default:
        break;
    }
  }

  if (this.isCompany) {
    switch (this.currentStep) {
      case 6:
        this.setCurrentStage(2)
        this.incrementCurrentStagePercentage();
        break;
      case 19:
        this.setCurrentStage(3)
        this.incrementCurrentStagePercentage();
        this.kycSrv.isInNeocheckStep(true);
        break;
      case 21:
        this.saveUserData();
        break;
      default:
        break;
    }
  }

  if(Object.keys(data).length > 0) {
    this.modalConnectionService.saveCurrentData(data,this.getCurrentStep(),this.getCurrentStage(),{stage1Progress:this.stage1Progress, stage2Progress:this.stage2Progress, stage3Progress:this.stage3Progress});
  }

  }

  // ===== Dirección: validación de código postal por país =====
  private isValidPostalCode(country: string, postal: string): boolean {
    if (!postal) return false;
    const normalizedCountry = country.toLowerCase();
    if (['españa','spain'].includes(normalizedCountry)) {
      if (!/^\d{5}$/.test(postal)) return false;
      const prefix = parseInt(postal.substring(0,2),10);
      return prefix >= 1 && prefix <= 52;
    }
    return /^[A-Za-z0-9\-\s]{3,10}$/.test(postal);
  }

  async backToKycStages() {
    const userData = await this.modalConnectionService.getUserData();
    if(userData?.kyc?.result == 2){
      this.kycSrv.setModalContent('completed');
      return;
    }
    //this.kycSrv.setStageData({nextStage: 3, nextStep: 1});
    this.kycSrv.isInNeocheckStep(false);
    //this.kycSrv.setModalContent('stages');
    this.kycSrv.setModalContent('completed');
    this.modalConnectionService.saveCurrentData({aux:true},0,3,{stage1Progress:this.stage1Progress, stage2Progress:this.stage2Progress, stage3Progress:this.stage3Progress});
  }

  getCurrentStep(){
    return this.currentStep;
  }

  getCurrentStage(){
    return this.currentStage;
  }

  incrementCurrentStep(){
    this.currentStep += 1;
  }

  decrementCurrentStep(){
    if (this.currentStage == 1 && this.currentStep == 1) {
      this.kycSrv.setStageData({nextStage: 1, nextStep: 1, backFromRegister: true, isPerson: this.isPerson, isCompany: this.isCompany});
      this.kycSrv.setModalContent('stages');
      this.modalConnectionService.saveCurrentData({aux:true},0,1);
    }
    if(this.currentStep == 14 && this.isPerson){
      this.currentStep--;
      this.currentStage--;
      if(this.isProfessionalInvestor =='No')
        this.currentStep--;
    }
    if(this.currentStep == 19 && this.currentStage == 3)
        this.currentStage--;
    if (this.currentStep == 6){
      if(this.companyIsProfessionalInvestor === 'No')
        this.currentStep -=1;
      this.currentStage -= this.currentStage > 1 ? 1 : 0;
      this.stage2Progress = 0;
      this.stage1Progress = 100;
    } 
    this.currentStep -= 1;
  }

  setCurrentStage(stage:number){
    this.currentStage = stage;
  }

  incrementCurrentStagePercentage(){
    switch (this.currentStage) {
      case 1:{
        if(this.isPerson) this.stage1Progress += 20;
        if(this.isCompany) this.stage1Progress += 25;
        break;
      }
      case 2:{
        if(this.isPerson) this.stage2Progress += 20;
        if(this.isCompany) this.stage2Progress += 14.29;
        break;
      }
      case 3:{
        this.stage3Progress += 50;
        break;
      }
    }
    // console.log(this.stage2Progress)
    // if(this.stage2Progress > 120)
    //   this.stage3Progress += 50;
  }

  decrementCurrentStagePercentage(){
    switch (this.currentStage) {
      case 1:{
        this.stage1Progress -= 20;
        break;
      }
      case 2:{
        this.stage2Progress -= 20;
        break;
      }
    }
    if(this.stage2Progress > 120)
      this.stage3Progress -= 50;
  }

  /** Nº de opciones marcadas en el paso "Cliente Profesional" (3ª opción: empresa=sup40m, particular=sup500k). */
  get professionalFieldsSelected(): number {
    let n = 0;
    n += this.lastoper ? 1 : 0;
    n += this.oper_job ? 1 : 0;
    n += (this.isPerson ? this.sup500k : this.sup40m) ? 1 : 0;
    return n;
  }

  /** Válido para avanzar como Cliente Profesional: casilla general + al menos 2 de las 3 opciones. */
  get professionalSelectionValid(): boolean {
    return !!this.requiredField && this.professionalFieldsSelected >= 2;
  }

  mandatoryFields(fb = ()=>{}){
      return (
        Swal.fire({
          title:'Campos obligatorios',
          text:'Por favor rellene todos los campos obligatorios para continuar',
          icon: 'warning'
        })
      ).then(fb)
  }

  /**
   * Muestra mensaje de error específico para teléfono
   */
  showPhoneValidationError(fb = ()=>{}){
      return (
        Swal.fire({
          title:'Número de teléfono inválido',
          text:'Por favor ingrese un número de teléfono español válido',
          icon: 'warning'
        })
      ).then(fb)
  }

  async close(){
    // if (this.currentStage >= 2) {
    //   this.dialogRef.close();
    //   return;
    // } 
    await this.authSrv.logout();
    this.dialogRef.close();
    this.router.navigateByUrl('/login');
    this.authSrv.reload();
  }

onFileChange(event: any) {
  for (let file of event.target.files) {
    this.files.push(file);
  }
}

removeFile(index: number) {
  this.files.splice(index, 1);
}

  clearFields(){
  this.companyRepresentName = null;
  this.companyRepresentLastname = null;
  this.companyRepresentBirthday = null;
  this.companyRepresentMailAddress = null;
  this.companyRepresentResidence = null;
  this.companyRepresentCity = null;
  this.companyRepresentProvince = null;
  this.companyRepresentNationality = null;
  this.companyRepresentAddress = null;
  this.phonePrefix = '';
  this.companyPhoneNumber = null;
  this.companyRepresentantisPoliticallyExposed = null;
  this.companyRepresentantisUsaCitizen = null;
  this.phoneValidationError = '';
}

  /**
   * Valida el número de teléfono español
   * Los números de teléfono españoles tienen 9 dígitos
   */
  validateSpanishPhone(): void {
    if (this.phonePrefix === '+34') {
      // Verificar si contiene caracteres no numéricos
      const hasNonNumeric = /[^0-9\s]/.test(this.phoneNumber);
      if (hasNonNumeric) {
        this.phoneValidationError = 'El número de teléfono solo puede contener dígitos';
        return;
      }
      
      // Remover espacios y caracteres no numéricos
      const cleanNumber = this.phoneNumber.replace(/\D/g, '');
      
      if (cleanNumber.length === 0) {
        this.phoneValidationError = '';
        return;
      }
      
      if (cleanNumber.length !== 9) {
        this.phoneValidationError = 'El número de teléfono español debe tener 9 dígitos';
      } else {
        // Validar que empiece con 6, 7, 8 o 9 (números móviles españoles)
        const firstDigit = cleanNumber.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
          this.phoneValidationError = 'El número de teléfono español debe empezar con 6, 7, 8 o 9';
        } else {
          this.phoneValidationError = '';
        }
      }
    } else {
      this.phoneValidationError = '';
    }
  }

  /**
   * Valida si el número de teléfono español es válido
   * Retorna true si es válido, false si no
   */
  isSpanishPhoneValid(): boolean {
    if (this.phonePrefix === '+34') {
      const cleanNumber = this.phoneNumber.replace(/\D/g, '');
      return cleanNumber.length === 9 && ['6', '7', '8', '9'].includes(cleanNumber.charAt(0));
    }
    return true; // Para otros países, no validamos
  }

  // ====== Google Places autosuggest integration (KYC address steps) ======
  // Fuerza el tema/estilos del input del web component para asegurar legibilidad
  private forceAutocompleteTheme() {
    try {
      const elements = document.querySelectorAll('gmp-place-autocomplete');
      elements.forEach((el) => this.styleGmpElement(el));
      this.observeAutocompleteInputs();
    } catch (e) {
      console.warn('No se pudo forzar el tema del autocomplete:', e);
    }
  }

  private styleGmpElement(element: Element) {
    // Host styles
    const host = element as HTMLElement;
    host.style.setProperty('color-scheme', 'light', 'important');
    host.style.setProperty('--color-scheme', 'light', 'important');

    // Shadow input styles + re-apply on focus/input to combat overrides
    const applyToInput = (inputEl: HTMLInputElement) => {
      inputEl.style.setProperty('color', '#222', 'important');
      inputEl.style.setProperty('-webkit-text-fill-color', '#222', 'important');
      inputEl.style.setProperty('background-color', '#fff', 'important');
      inputEl.style.setProperty('caret-color', '#222', 'important');
      inputEl.style.setProperty('text-fill-color', '#222', 'important' as any);
    };

    const wireInput = (inputEl: HTMLInputElement) => {
      applyToInput(inputEl);
      const reapply = () => applyToInput(inputEl);
      inputEl.addEventListener('focus', reapply, { passive: true });
      inputEl.addEventListener('input', reapply, { passive: true });
      inputEl.addEventListener('change', reapply, { passive: true });
    };

    const tryShadow = () => {
      const shadow: any = (element as any).shadowRoot;
      if (shadow) {
        const input: HTMLInputElement | null = shadow.querySelector('input');
        if (input) wireInput(input);
      }
    };

    tryShadow();
    // Some components attach the input a bit later; retry shortly
    setTimeout(tryShadow, 50);
    setTimeout(tryShadow, 150);
  }

  private _gmpObserver?: MutationObserver;
  private observeAutocompleteInputs() {
    if (this._gmpObserver) return;
    this._gmpObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList') {
          m.addedNodes.forEach((n) => {
            if (n instanceof HTMLElement) {
              if (n.matches && n.matches('gmp-place-autocomplete')) {
                this.styleGmpElement(n);
              }
              // Also check inside containers
              const found = n.querySelectorAll?.('gmp-place-autocomplete');
              if (found && found.length) {
                found.forEach((el) => this.styleGmpElement(el));
              }
            }
          });
        }
      }
    });
    this._gmpObserver.observe(document.body, { childList: true, subtree: true });
  }

  togglePersonManualAddress(forceManual?: boolean): void {
    const nextState = forceManual !== undefined ? forceManual : !this.isPersonManualAddress;
    this.isPersonManualAddress = nextState;
    this.clearAddressContext('person');
    this.personAddressQuery = '';
    this.selectedAddressPerson = '';
  }

  get showPersonAddressFields(): boolean {
    return this.isPersonManualAddress
      || !!this.selectedAddressPerson
      || !!(this.address || this.city || this.province || this.mailAddress);
  }

  private clearAddressContext(context: 'person' | 'company' | 'rep'): void {
    if (context === 'person') {
      this.address = '';
      this.city = '';
      this.province = '';
      this.mailAddress = '';
      this.selectedAddressPerson = '';
      return;
    }

    if (context === 'company') {
      this.companyAddress = '';
      this.province_company = '';
      this.companyMailAddress = '';
      this.companyPostalCode = '';
      return;
    }

    this.companyRepresentAddress = '';
    this.companyRepresentCity = '';
    this.companyRepresentProvince = '';
    this.companyRepresentMailAddress = '';
  }
  // Map English country names to Spanish for consistency
  private mapCountryToSpanish(countryName: string): string {
    if (!countryName) return 'España';
    const countryMapping: { [key: string]: string } = {
      'Spain': 'España', 'Portugal': 'Portugal', 'France': 'Francia', 'Germany': 'Alemania',
      'Italy': 'Italia', 'United Kingdom': 'Reino Unido', 'Netherlands': 'Países Bajos', 'Belgium': 'Bélgica',
      'Switzerland': 'Suiza', 'Austria': 'Austria', 'Poland': 'Polonia', 'Czech Republic': 'República Checa',
      'Hungary': 'Hungría', 'Sweden': 'Suecia', 'Norway': 'Noruega', 'Denmark': 'Dinamarca', 'Finland': 'Finlandia',
      'United States': 'Estados Unidos', 'Canada': 'Canadá', 'Mexico': 'México', 'Brazil': 'Brasil', 'Argentina': 'Argentina',
      'Chile': 'Chile', 'Colombia': 'Colombia', 'Peru': 'Perú', 'Uruguay': 'Uruguay', 'Ireland': 'Irlanda',
      'Luxembourg': 'Luxemburgo', 'Greece': 'Grecia', 'Cyprus': 'Chipre', 'Malta': 'Malta', 'Slovenia': 'Eslovenia',
      'Slovakia': 'Eslovaquia', 'Croatia': 'Croacia', 'Bulgaria': 'Bulgaria', 'Romania': 'Rumania', 'Lithuania': 'Lituania',
      'Latvia': 'Letonia', 'Estonia': 'Estonia'
    };
    return countryMapping[countryName] || countryName;
  }

  // Get Google Places component restrictions by current country selection
  // Returns undefined if no valid ISO country can be resolved, so the property is not set at all
  getKycComponentRestrictions(context: 'person' | 'company' | 'rep'): { country: string | string[] } | undefined {
    let rawCountry = 'España';
    if (context === 'person' && this.residence) rawCountry = this.residence;
    if (context === 'company' && this.companyResidence) rawCountry = this.companyResidence;
    if (context === 'rep' && this.companyRepresentResidence) rawCountry = this.companyRepresentResidence;

    const normalize = (str: string) => str
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '') // remove accents
      .replace(/\./g,'')
      .trim();

    const countryKey = normalize(rawCountry);

    // Comprehensive mapping ES/EN (accent-insensitive) for common jurisdictions
    const mapToIso: { [canonical: string]: string } = {
      'espana':'ES','spain':'ES',
      'portugal':'PT',
      'francia':'FR','france':'FR',
      'alemania':'DE','germany':'DE',
      'italia':'IT','italy':'IT',
      'reino unido':'GB','united kingdom':'GB','uk':'GB','gran bretana':'GB','great britain':'GB','britain':'GB',
      'irlanda':'IE','ireland':'IE',
      'paises bajos':'NL','netherlands':'NL','holanda':'NL','holland':'NL',
      'belgica':'BE','belgium':'BE',
      'suiza':'CH','switzerland':'CH',
  'austria':'AT',
      'polonia':'PL','poland':'PL',
      'república checa':'CZ','republica checa':'CZ','czech republic':'CZ','czechia':'CZ',
      'hungria':'HU','hungary':'HU',
      'suecia':'SE','sweden':'SE',
      'noruega':'NO','norway':'NO',
      'dinamarca':'DK','denmark':'DK',
      'finlandia':'FI','finland':'FI',
  'estonia':'EE',
      'letonia':'LV','latvia':'LV',
      'lituania':'LT','lithuania':'LT',
      'irlanda del norte':'GB','northern ireland':'GB',
      'escocia':'GB','scotland':'GB',
      'gales':'GB','wales':'GB',
      'estados unidos':'US','estados unidos de america':'US','usa':'US','eeuu':'US','ee.uu':'US','united states':'US','united states of america':'US','us':'US','u.s.':'US',
      'canada':'CA','canadá':'CA',
      'mexico':'MX','méxico':'MX',
      'brasil':'BR','brazil':'BR',
      'argentina':'AR',
      'chile':'CL',
      'colombia':'CO',
      'peru':'PE','perú':'PE',
      'uruguay':'UY',
      'paraguay':'PY',
      'bolivia':'BO',
      'ecuador':'EC',
      'venezuela':'VE',
      'panama':'PA','panamá':'PA',
      'costa rica':'CR',
      'nicaragua':'NI',
      'guatemala':'GT',
      'el salvador':'SV',
      'honduras':'HN',
      'dominican republic':'DO','republica dominicana':'DO',
      'cuba':'CU',
      'china':'CN','república popular china':'CN','republica popular china':'CN','people s republic of china':'CN','peoples republic of china':'CN',
      'japon':'JP','japón':'JP','japan':'JP',
      'corea del sur':'KR','south korea':'KR','republic of korea':'KR',
      'corea del norte':'KP','north korea':'KP','dprk':'KP',
      'india':'IN',
      'rusia':'RU','russia':'RU','federacion rusa':'RU','federación rusa':'RU',
      'australia':'AU',
      'nueva zelanda':'NZ','new zealand':'NZ',
      'turquia':'TR','turquía':'TR','turkey':'TR',
      'grecia':'GR','greece':'GR',
      'chipre':'CY','cyprus':'CY',
  'malta':'MT',
      'eslovenia':'SI','slovenia':'SI',
      'eslovaquia':'SK','slovakia':'SK',
      'croacia':'HR','croatia':'HR',
  'bulgaria':'BG',
      'rumania':'RO','romania':'RO','rumanía':'RO',
  'serbia':'RS',
      'bosnia':'BA','bosnia y herzegovina':'BA','bosnia and herzegovina':'BA',
  'montenegro':'ME',
      'macedonia':'MK','north macedonia':'MK','macedonia del norte':'MK',
  'albania':'AL',
  'andorra':'AD',
  'liechtenstein':'LI',
  'san marino':'SM',
      'monaco':'MC','mónaco':'MC',
      'luxemburgo':'LU','luxembourg':'LU',
      'pais vasco':'ES','cataluna':'ES','cataluña':'ES','galicia':'ES' // regional -> Spain
    };

    const iso = mapToIso[countryKey] || '';
    return iso ? { country: iso } : undefined;
  }

  // Parse address components from the new Places API object
  private extractFromNewPlace(place: any) {
    let streetNumber = '';
    let route = '';
    let locality = '';
    let administrativeArea = '';
    let postalCode = '';
    let country = '';

    const components = place.addressComponents || [];
    for (const comp of components) {
      const types = comp.types || [];
      if (types.includes('street_number')) streetNumber = comp.longText || comp.long_name || '';
      if (types.includes('route')) route = comp.longText || comp.long_name || '';
      if (types.includes('locality')) locality = comp.longText || comp.long_name || '';
      if (types.includes('administrative_area_level_1')) administrativeArea = comp.longText || comp.long_name || '';
      if (types.includes('postal_code')) postalCode = comp.longText || comp.long_name || '';
      if (types.includes('country')) country = comp.longText || comp.long_name || '';
    }

    const fullAddress = `${route} ${streetNumber}`.trim();
    return {
      address: fullAddress,
      city: locality,
      province: administrativeArea,
      postalCode,
      country: this.mapCountryToSpanish(country) || 'España'
    };
  }

  // Generic handler to fill fields depending on context
  private applyAddressToContext(context: 'person' | 'company' | 'rep', data: { address: string; city: string; province: string; postalCode: string; country: string; }) {
    if (context === 'person') {
      this.address = data.address || this.address;
      this.city = data.city || this.city;
      this.province = data.province || this.province;
      // Prefer explicit postalCode over existing mailAddress
      this.postalCode = data.postalCode || this.postalCode;
      if (data.postalCode) this.mailAddress = data.postalCode; // override for consistency
      if (data.country) this.residence = data.country; // always override country to reflect selection
    } else if (context === 'company') {
      this.companyAddress = data.address || this.companyAddress;
      this.province_company = data.province || this.province_company;
      // Prefer explicit postalCode over existing
      if (data.postalCode) this.companyMailAddress = data.postalCode;
      if (data.postalCode) this.companyPostalCode = data.postalCode;
      if (data.country) this.companyResidence = data.country;
    } else {
      // Representative
      this.companyRepresentAddress = data.address || this.companyRepresentAddress;
      this.companyRepresentCity = data.city || this.companyRepresentCity;
      this.companyRepresentProvince = data.province || this.companyRepresentProvince;
      if (data.postalCode) this.companyRepresentMailAddress = data.postalCode;
      if (data.country) this.companyRepresentResidence = data.country;
    }
  }

  // Show popup if critical fields are missing
  private async ensureAddressCompleteness(context: 'person' | 'company' | 'rep'): Promise<void> {
    let needsProvince = false;
    let needsPostal = false;
    if (context === 'person') {
      needsProvince = !this.province || !this.province.trim();
      needsPostal = !(this.mailAddress && this.mailAddress.trim()) && !(this.postalCode && this.postalCode.trim());
    } else if (context === 'company') {
      needsProvince = !this.province_company || !this.province_company.trim();
      needsPostal = !this.companyMailAddress || !this.companyMailAddress.trim();
    } else {
      needsProvince = !this.companyRepresentProvince || !this.companyRepresentProvince.trim();
      needsPostal = !this.companyRepresentMailAddress || !this.companyRepresentMailAddress.trim();
    }

    if (!needsProvince && !needsPostal) return;

    const htmlParts: string[] = [];
    if (needsProvince) {
      htmlParts.push(`
        <div style="margin-bottom: 1rem; text-align: center;">
          <label style="display:block;margin-bottom:0.5rem;font-weight:600;">Provincia/Estado *</label>
          <input type="text" id="popup-province" class="swal2-input" placeholder="Ej: Madrid" style="width:80%;max-width:300px;">
        </div>
      `);
    }
    if (needsPostal) {
      htmlParts.push(`
        <div style="margin-bottom: 1rem; text-align: center;">
          <label style="display:block;margin-bottom:0.5rem;font-weight:600;">Código postal *</label>
          <input type="text" id="popup-postal" class="swal2-input" placeholder="Ej: 28001" style="width:80%;max-width:300px;">
        </div>
      `);
    }

    const { value: formValues } = await Swal.fire({
      title: 'Faltan datos de la dirección',
      html: htmlParts.join(''),
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      preConfirm: () => {
        const out: any = {};
        if (needsProvince) {
          const el = document.getElementById('popup-province') as HTMLInputElement;
          out.province = el?.value || '';
          if (!out.province.trim()) {
            Swal.showValidationMessage('La provincia/estado es obligatoria');
            return false;
          }
        }
        if (needsPostal) {
          const el = document.getElementById('popup-postal') as HTMLInputElement;
          out.postal = el?.value || '';
          if (!out.postal.trim()) {
            Swal.showValidationMessage('El código postal es obligatorio');
            return false;
          }
        }
        return out;
      }
    });

    if (formValues) {
      if (context === 'person') {
        if (formValues.province) this.province = formValues.province;
        if (formValues.postal) {
          this.postalCode = formValues.postal;
          this.mailAddress = this.mailAddress || formValues.postal;
        }
      } else if (context === 'company') {
        if (formValues.province) this.province_company = formValues.province;
        if (formValues.postal) this.companyMailAddress = formValues.postal;
      } else {
        if (formValues.province) this.companyRepresentProvince = formValues.province;
        if (formValues.postal) this.companyRepresentMailAddress = formValues.postal;
      }
    }
  }

  private async geocodeManualPersonAddress(request: any, label: string): Promise<void> {
    await this.mapsLoader.load(['places']);
    if (!google?.maps?.Geocoder) {
      throw new Error('Google Maps no está disponible');
    }

    const geocodeResults: any[] = await new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(request, (results: any[], status: string) => {
        if (status === 'OK' && results?.length) {
          resolve(results);
        } else {
          reject(new Error(`Geocode falló (${status || 'SIN_STATUS'})`));
        }
      });
    });

    const firstResult = geocodeResults[0];
    const mappedComponents = (firstResult.address_components || []).map((comp: any) => ({
      types: comp.types || [],
      longText: comp.long_name || comp.short_name || '',
      long_name: comp.long_name || ''
    }));
    const pseudoPlace = { addressComponents: mappedComponents };
    const data = this.extractFromNewPlace(pseudoPlace);
    this.clearAddressContext('person');
    this.applyAddressToContext('person', data);
    this.selectedAddressPerson = firstResult.formatted_address || label;
    this.personAddressQuery = this.selectedAddressPerson;
    await this.ensureAddressCompleteness('person');
  }

  async onPlaceSelectedPerson(event: any) {
    const prediction = event?.placePrediction;
    const fallbackText = prediction?.text || prediction?.structuredFormat?.mainText || event?.target?.value || this.personAddressQuery || '';
    this.isPersonManualAddress = false;

    const geocodeFallback = async (query: string) => {
      const normalized = (query || '').trim();
      if (!normalized) return;
      const request: any = { address: normalized };
      const restrictions = this.getKycComponentRestrictions('person');
      if (restrictions) {
        request.componentRestrictions = restrictions;
      }
      await this.geocodeManualPersonAddress(request, normalized);
    };

    try {
      if (!prediction || !prediction.toPlace) {
        await geocodeFallback(fallbackText);
        return;
      }

      const place = prediction.toPlace();
      await place.fetchFields({ fields: ['addressComponents', 'formattedAddress', 'types'] });
      const data = this.extractFromNewPlace(place);
      this.clearAddressContext('person');
      this.applyAddressToContext('person', data);

      const formatted = place.formattedAddress || fallbackText;
      if (formatted) {
        this.selectedAddressPerson = formatted;
        this.personAddressQuery = formatted;
      }

      const types: string[] = place.types || [];
      const insufficientDetail = types.includes('country') && (!data.address && !data.city && !data.province && !data.postalCode);

      if (insufficientDetail && formatted) {
        await geocodeFallback(formatted);
        return;
      }

      await this.ensureAddressCompleteness('person');
    } catch (error) {
      console.error('Error procesando dirección (persona):', error);
      await geocodeFallback(fallbackText);
    }
  }

  async onPlaceSelectedCompany(event: any) {
    try {
      const prediction = event?.placePrediction;
      if (!prediction || !prediction.toPlace) return;
      const place = prediction.toPlace();
      await place.fetchFields({ fields: ['addressComponents', 'formattedAddress', 'types'] });
      const data = this.extractFromNewPlace(place);
      this.clearAddressContext('company');
      this.applyAddressToContext('company', data);
      const types: string[] = place.types || [];
      const isCountryOnly = types.includes('country') && (!data.address && !data.city && !data.province && !data.postalCode);
      if (isCountryOnly) {
        this.companyAddress = '';
        this.province_company = '';
        this.companyMailAddress = '';
        this.companyPostalCode = '';
      }
      await this.ensureAddressCompleteness('company');
    } catch (e) {
      console.error('Error procesando dirección (empresa):', e);
    }
  }

  async onPlaceSelectedRep(event: any) {
    try {
      const prediction = event?.placePrediction;
      if (!prediction || !prediction.toPlace) return;
      const place = prediction.toPlace();
      await place.fetchFields({ fields: ['addressComponents', 'formattedAddress', 'types'] });
      const data = this.extractFromNewPlace(place);
      this.clearAddressContext('rep');
      this.applyAddressToContext('rep', data);
      const types: string[] = place.types || [];
      const isCountryOnly = types.includes('country') && (!data.address && !data.city && !data.province && !data.postalCode);
      if (isCountryOnly) {
        this.companyRepresentAddress = '';
        this.companyRepresentCity = '';
        this.companyRepresentProvince = '';
        this.companyRepresentMailAddress = '';
      }
      await this.ensureAddressCompleteness('rep');
    } catch (e) {
      console.error('Error procesando dirección (representante):', e);
    }
  }

  /**
   * Filtra la entrada del teléfono para permitir solo números y espacios
   */
  filterPhoneInput(event: KeyboardEvent): void {
    const char = String.fromCharCode(event.which);
    // Permitir solo números, espacios, backspace, delete, tab, escape, enter
    if (!/[0-9\s]/.test(char) && !this.isSpecialKey(event)) {
      event.preventDefault();
    }
  }

  /**
   * Verifica si la tecla presionada es una tecla especial (backspace, delete, etc.)
   */
  private isSpecialKey(event: KeyboardEvent): boolean {
    return event.key === 'Backspace' || 
           event.key === 'Delete' || 
           event.key === 'Tab' || 
           event.key === 'Escape' || 
           event.key === 'Enter' ||
           event.key === 'ArrowLeft' ||
           event.key === 'ArrowRight' ||
           event.key === 'ArrowUp' ||
           event.key === 'ArrowDown';
  }

async uploadActa(e: any) {
  this.loadingMessage = 'Subiendo archivo del acta...';
  this.isLoading = true;
  const uid = this.modalConnectionService.getUserUid();
  const file = e.target.files[0];
  if(!file){
    this.mandatoryFields();
    return;
  }
  if(file.size > 20971520){
    this.isLoading = false;
    Swal.fire({
      title:'Limite de peso excedido',
      text:'Ha sobrepasado el tamaño limite permitido del archivo, intente con un archivo mas ligero',
      icon:'warning'
    });
    return;
  }
  const filePath = `enterprisedocs/${uid}/${file.name}`;
  const fileRef = this.storageService.ref(filePath);
  const task = this.storageService.upload(filePath, file);
  task.snapshotChanges().pipe(
    finalize(() => {
      fileRef.getDownloadURL().subscribe(async(res: string) => {
        this.acta = res;
        this.fileacta = file.name
        if (this.acta !== null && this.acta !== undefined) {
          this.files.push({label: 'Acta', file: file})
        }
        if (this.acta === null || this.acta === undefined) {
          Swal.fire({
            title: 'Error al subir el archivo',
            text: 'Por favor, vuelve a intentarlo',
            icon: 'error'
          });
        }
        await this.modalConnectionService.saveCurrentData({fileacta:this.fileacta},this.currentStep,this.currentStage);
        this.isLoading = false;
      })
    })).subscribe();
}

async uploadEscritura(e: any) {
  this.isLoading = true;
  this.loadingMessage = 'Subiendo archivo de escritura...';
  const uid = this.modalConnectionService.getUserUid();
  const file = e.target.files[0];
  if(!file){
    this.mandatoryFields()
    return;
  }
  const filePath = `enterprisedocs/${uid}/${file.name}`;
  const fileRef = this.storageService.ref(filePath);
  const task = this.storageService.upload(filePath, file);
  task.snapshotChanges().pipe(
    finalize(() => {
      
      fileRef.getDownloadURL().subscribe(async (res: string) => {
        this.escrituras = res;
        this.filescrito = file.name
        if (this.escrituras !== null && this.escrituras !== undefined) {
          this.files.push({label: 'Escritura', file: file})
        }
        if (this.escrituras === null || this.escrituras === undefined) {
          Swal.fire({
            title: 'Error al subir el archivo',
            text: 'Por favor, vuelve a intentarlo',
            icon: 'error'
          });
        }
        console.log(this.escrituras,this.escrituras)
        await this.modalConnectionService.saveCurrentData({fileescrito:this.filescrito},this.currentStep,this.currentStage);
        this.isLoading = false;
      });
    })).subscribe();
}

get uploadedEscrituraFile(): boolean {
  const res = this.files.some((file: any) => file.label === 'Escritura');
  return !res
}

get uploadedActaFile(): boolean {
  const res = this.files.some((file: any) => file.label === 'Acta');
  return !res
}

get uploadedOtrosFile(): boolean {
  const res = this.files.some((file: any) => file.label === 'Otros');
  return !res
}

async uploadDocs(e: any) {
  this.loadingMessage = 'Subiendo archivo de otros documentos...';
  this.isLoading = true;
  const uid = this.modalConnectionService.getUserUid();
  const file = e.target.files[0];
  if(!file){
    this.mandatoryFields();
    return;
  }
  const filePath = `enterprisedocs/${uid}/${file.name}`;
  const fileRef = this.storageService.ref(filePath);
  const task = this.storageService.upload(filePath, file);
  task.snapshotChanges().pipe(
    finalize(() => {
      fileRef.getDownloadURL().subscribe(async (res: string) => {
        this.otrosdoc = res;
        this.fileotros = file.name
        if (this.fileotros !== null && this.fileotros !== undefined) {
          this.files.push({label: 'Otros', file: file})
        }
        if (this.fileotros === null || this.fileotros === undefined) {
          Swal.fire({
            title: 'Error al subir el archivo',
            text: 'Por favor, vuelve a intentarlo',
            icon: 'error'
          });
        }
        await this.modalConnectionService.saveCurrentData({fileotros:this.fileotros},this.currentStep,this.currentStage);
        this.isLoading = false;
      });
      console.log(this.otrosdoc,this.fileotros)
    })).subscribe();
}

clickKnowledge_quiebra(){
  Swal.fire({
    title: 'Necesitamos confirmar que conoces lo que es un préstamo participativo y los riesgos que la inversión en los mismos conlleva.',
    html: `
      <p>El préstamo participativo es un instrumento financiero que se sitúa entre el capital social y el préstamo tradicional. Su principal particularidad radica en que su retribución está directamente ligada al desempeño de la sociedad prestataria. En este contexto, Domoblock ha digitalizado este concepto al asociarlo a la plusvalía generada por la remodelación o reforma de un inmueble. De esta manera, el inversor recibirá un interés que se ajustará según el progreso del proyecto inmobiliario.</p>
      <div>
        <input type="checkbox" id="confirmCheckbox">
        <label for="confirmCheckbox">Entiendo lo que es un préstamo participativo y los riesgos que conlleva</label>
      </div>
    `,
    icon: 'warning',
    width: '98%',
    customClass: {
      popup: 'custom-swal-width' // Añade una clase personalizada al popup
    },
    preConfirm: () => {
      const checkbox = document.getElementById('confirmCheckbox') as HTMLInputElement;
      if (!checkbox.checked) {
        Swal.showValidationMessage('Debes confirmar que entiendes los riesgos');
        return;
      }
      this.knowledge_quiebra = 'Si';
    }
  });
}

  ngOnDestroy(): void {
    // Limpia la suscripción al salir del componente
    if (this.kycResultSub) {
      this.kycResultSub.unsubscribe();
    }
  }
}

// Helper opcional (fallback local) para limpiar undefined/NaN de objetos
function deepClean<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') return obj;
  const out: any = Array.isArray(obj) ? [] : {};
  Object.entries(obj as any).forEach(([k, v]) => {
    if (v === undefined || Number.isNaN(v)) return; // descarta undefined/NaN
    if (v && typeof v === 'object') {
      const cleaned = deepClean(v);
      // No guardes objetos vacíos
      if (cleaned && (Array.isArray(cleaned) ? cleaned.length : Object.keys(cleaned).length)) {
        out[k] = cleaned;
      }
    } else {
      out[k] = v;
    }
  });
  return out;
}

